import { logAction } from "./admin-api";

export async function audit(
  action: string,
  opts?: { entity?: string; entity_id?: string; metadata?: Record<string, any> }
) {
  try {
    await logAction({ action, ...opts });
  } catch (err) {
    // Never block the user flow on audit failure
    console.warn("[audit] failed", action, err);
  }
}
